import React from 'react';
import BackBtn from '../BackBtn'
import NextBtn from '../NextBtn'
import {Flex, SVGButton, SVG} from '/app/src/component';
import Theme from '/app/src/theme';
import DotProgress from '../DotProgress'

const linkStyle = {
    cursor: 'pointer',
    marginTop: '5px'
}

const linkIconStyle = {
    height: '8px',
    maxWidth: '8px',
    marginTop: '4px',
    marginLeft: '2px'
}

const fineprintStyle = {
    fontSize: '11px',
    color: 'MediumGray7'
}
const largeTextStyle = {
    fontSize: '30px',
    color: 'darkblue'
}

const optionsStyle = {
    paddingTop: '40px'
}
const buttonStyle = {
    backgroundHover: 'LightBlue1',
    height: '40px',
    hover: 'JibberBlue_M',
    color: 'MediumGray5'
}
const yearlyBtnContainer = {
    position: 'relative'
}
const discountStyle = {
    position: 'absolute',
    top: '-17px',
    fontSize:'12px',
    color: 'JibberBlue_M',
    fontWeight: '500',
    left: '10px',
    overflow: 'visible',
    whiteSpace: 'nowrap',
}

const dotProgressStyle = {
    paddingBottom: '10px',
    hAlignContent: 'center',
    backgroundColor: 'red',
    background: `linear-gradient(to left, #F0F0F0 0, #F0F0F0 30%, transparent 30%)`
}

class PlanPage extends React.Component {
    _renderRow(rowTitle, cmp, height) {
        const rowStyle = {height: height, shrink: 0};
        const rowTitleStyle = {
            hAlignContent: 'right',
            paddingTop: '5px',
            basis: '40%',
            marginRight: '40px',
            fontSize: '20px',
            color: 'DarkGray',
            fontWeight: 300
        };
        return <Flex  {...rowStyle}>
            <Flex {...rowTitleStyle}>
                {rowTitle}
            </Flex>
            <Flex grow>
                {cmp}
            </Flex>
        </Flex>
    }

    _summaryRow(rowTitle, rowText) {
        const rowTitleStyle = {
            width: '30%',
            hAlignContent:'right',
            fontSize: '13px',
            color: 'MediumGray7'
        }
        const rowTextStyle = {
            hAlignContent:'right',
            fontSize: '13px',
            fontWeight: '500',
            color: 'MediumGray7'
        }
        const rowContainerStyle = {marginTop: '10px'}
        const {translatePlan} = this.props
        return (
            <Flex {...rowContainerStyle}>
                <Flex {...rowTitleStyle}>{rowTitle}</Flex>
                <Flex {...rowTextStyle} grow>{translatePlan(rowText)}</Flex>
            </Flex>
        )
    }

    _discount(discount) {
        const {translatePlan} = this.props
        const rowTitleStyle = {
            width: '30%',
            hAlignContent:'right',
            fontSize: '13px',
            color: 'JibberBlue_M'
        }
        const rowTextStyle = {
            hAlignContent:'right',
            fontSize: '13px',
            fontWeight: '500',
            color: 'JibberBlue_M'
        }
        const rowContainerStyle = {marginTop: '10px'}
        return (
            <Flex {...rowContainerStyle}>
                <Flex {...rowTitleStyle}>{'Rabatt'}</Flex>
                <Flex {...rowTextStyle} grow>{translatePlan(discount) + ':-'}</Flex>
            </Flex>
        )
    }

    _renderSummary() {
        const {nbrEmployees, plan, subscription, nextButtonClick, calculateTotal} = this.props
        const containerStyle = {
            width: '100%',
            hAlignContent:'center'
        }
        const wrapperStyle = {
            width:'90%'
        }
        const headerStyle = {
            hAlignContent: 'center',
            marginTop: '40px',
            marginBottom: '25px',
            color: 'MediumGray7'
        }
        const btnWrapperStyle = {
            width: '100%',
            hAlignContent: 'right',
            padding: '0px 25px 10px 0px'
        }
        const hrStyle = {
            width: '100%',
            borderWidth: '2px',
            margin: '15px 0px',
            borderLeft: 'none'
        }

        const total = calculateTotal(plan, subscription)
        const discount = calculateTotal(plan, 'monthly') -  total
        return (
            <Flex {...containerStyle} column>
                <Flex {...wrapperStyle} column grow>
                    <Flex {...headerStyle}> Sammanräkning </Flex>
                    {this._summaryRow('Prisplan:', plan)}
                    {this._summaryRow('Avtal:', subscription)}
                    {this._summaryRow('Användare:', nbrEmployees + 'x')}
                    <Flex color='#4E4E4E'>
                        <hr style={hrStyle}/>
                    </Flex>
                    {this._summaryRow('Månadspris:', total)}
                    {discount > 0 && this._discount(discount)}
                </Flex>
                <Flex {...btnWrapperStyle} hAlignContent='right'>
                    <NextBtn
                        onClick={nextButtonClick}
                        text='Fortsätt'
                        src='/images/ArrowDirection_Right_S.svg'
                        iconPos='right'
                        fineText='Till faktureringsuppgifter'/>
                </Flex>
            </Flex>
        )
    }

    render() {
        const {nbrEmployees, plan, subscription, backButtonClick, handleButtonClick,
            calculateTotal } = this.props
        const total = calculateTotal(plan, 'monthly')
        const discount = (total - calculateTotal(plan, 'yearly'))*12
        const pricePlanRow = (
            <Flex>
                <SVGButton
                    active={plan === 'start' || plan === 'standard'}
                    onClick={() => handleButtonClick('startBtn')}
                    border text='Start'
                    {...buttonStyle}/>
                <SVGButton
                    active={plan === 'pro'}
                    marginLeft='16px'
                    onClick={() => handleButtonClick('proBtn')}
                    border text='PRO'
                    {...buttonStyle}/>
            </Flex>
        )
        const contractPlanRow = (
            <Flex column>
                <Flex>
                    <SVGButton
                        active={subscription === 'monthly'}
                        {...buttonStyle}
                        border
                        text='Månadsavtal'
                        onClick={() => handleButtonClick('monthlyBtn')}/>
                    <Flex {...yearlyBtnContainer}>
                        <Flex {...discountStyle}>
                            Du sparar {discount}kr/år!
                        </Flex>
                        <SVGButton
                            active={subscription === 'yearly'}
                            {...buttonStyle}
                            marginLeft='16px'
                            border
                            onClick={() => handleButtonClick('yearlyBtn')}
                            text='Årsavtal'/>
                    </Flex>
                </Flex>
                <Flex>
                    <Flex {...fineprintStyle} {...linkStyle}
                        onClick={() => {window.open('https://jibber.se/terms')}}>
                        Debiteras retroaktivt vid satt datum. Se betalningsvillkor
                    </Flex>
                    <Flex>
                        <img style={linkIconStyle} src='/images/TransferArrowGrey.png' alt=''/>
                    </Flex>
                </Flex>
            </Flex>
        )
        const nbrUserIconStyle = {fill: Theme.colors.JibberBlue_M, height: '35px', width: '35px', marginRight: '8px'}
        const nbrUsersRow = (
            <Flex {...largeTextStyle} column>
                <Flex>
                    <SVG cacheGetRequests={true}
                        style={nbrUserIconStyle}
                        src='/images/Employee_M.svg' />
                        {nbrEmployees}
                </Flex>
                <Flex {...fineprintStyle}>
                    Nya användare läggs in manuellt under Hantera Medarbetare.
                </Flex>
            </Flex>
        )

        const totalRow = (
            <Flex {...largeTextStyle}>
                {calculateTotal(plan, subscription)} /månad
            </Flex>
        )

        return <Flex column grow>
            <Flex grow>
                <Flex width='70%' column>
                    <Flex grow column {...optionsStyle}>
                        {this._renderRow('Prisplan', pricePlanRow, '65px')}
                        {this._renderRow('Avtalsplan', contractPlanRow, '65px')}
                        {this._renderRow('Antal Användare', nbrUsersRow, '120px')}
                        {this._renderRow('Totalpris', totalRow, '43px')}
                    </Flex>
                    <Flex>
                        { backButtonClick && <BackBtn onClick={backButtonClick} text='Tillbaka'/>}
                    </Flex>
                </Flex>
                <Flex bg='#F0F0F0' width='30%'>
                    {this._renderSummary()}
                </Flex>
            </Flex>
            <Flex {...dotProgressStyle}>
                <Flex>
                    <DotProgress currentPage={0}/>
                </Flex>
            </Flex>
        </Flex>
    }
}

export default PlanPage



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/Pages/PlanPage.js